import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const Logout = () => {
  const navigate = useNavigate();
  const auth = localStorage.removeItem("token");

  useEffect(() => {
    if (!auth) {
      navigate("/");
    }
    window.open(`${process.env.REACT_APP_API_BASE_URL}/auth/logout`, "_self");
  }, []);
  return <></>;
};

export default Logout;
